import { useState, useEffect } from 'react';
import { Card, Table, Statistic, Row, Col, DatePicker, Button, Space, Spin } from 'antd';
import { BarChartOutlined, DollarOutlined, UserOutlined, ThunderboltOutlined } from '@ant-design/icons';
import { adminAPI } from '../services/api';
import { t } from '../utils/i18n';
import dayjs from 'dayjs';

const { RangePicker } = DatePicker;

const UsageDashboard = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);
  const [ranking, setRanking] = useState([]);
  const [dates, setDates] = useState([dayjs().subtract(90, 'day'), dayjs()]);

  const fetchData = async () => {
    setLoading(true);
    try {
      const params = {};
      if (dates[0]) params.start = dates[0].format('YYYY-MM-DD');
      if (dates[1]) params.end = dates[1].format('YYYY-MM-DD');

      const [dashRes, rankRes] = await Promise.all([
        adminAPI.getUsageDashboard(params),
        adminAPI.getUsageRanking(params),
      ]);
      if (dashRes.code === 0) setData(dashRes.data);
      if (rankRes.code === 0) setRanking(rankRes.data?.ranking || []);
    } catch (e) { console.error(e); }
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, []);

  const rankColumns = [
    { title: '排名', key: 'rank', render: (_, __, i) => i + 1, width: 60 },
    { title: '模型', dataIndex: 'model', key: 'model' },
    { title: '用户数', dataIndex: 'user_count', key: 'users' },
    { title: '调用次数', dataIndex: 'call_count', key: 'calls' },
    { title: '总金额', dataIndex: 'amount', key: 'amount', render: v => `$${(v||0).toFixed(2)}` },
    { title: '日均', dataIndex: 'avg_daily', key: 'daily', render: v => `$${(v||0).toFixed(2)}` },
  ];

  return (
    <div style={{ padding: 24 }}>
      <h2><BarChartOutlined /> {t('usage_statistics')}</h2>
      <Space style={{ marginBottom: 16 }}>
        <RangePicker value={dates} onChange={setDates} />
        <Button type="primary" onClick={fetchData}>查询</Button>
      </Space>

      <Spin spinning={loading}>
        <Row gutter={16} style={{ marginBottom: 24 }}>
          <Col span={6}><Card><Statistic title="总营收" value={data?.kpi?.total_revenue || 0} precision={2} prefix="$" suffix="USD" /></Card></Col>
          <Col span={6}><Card><Statistic title="活跃用户" value={data?.kpi?.active_users || 0} prefix={<UserOutlined/>} /></Card></Col>
          <Col span={6}><Card><Statistic title="总调用" value={data?.kpi?.total_calls || 0} prefix={<ThunderboltOutlined/>} /></Card></Col>
        </Row>

        <Card title="模型消耗排行" style={{ marginBottom: 24 }}>
          <Table columns={rankColumns} dataSource={ranking} rowKey="model" size="small" pagination={false}
            summary={() => ranking.length > 0 ? (
              <Table.Summary.Row>
                <Table.Summary.Cell colSpan={3}><strong>合计</strong></Table.Summary.Cell>
                <Table.Summary.Cell>{ranking.reduce((s,r) => s+(r.call_count||0), 0)}</Table.Summary.Cell>
                <Table.Summary.Cell><strong>${ranking.reduce((s,r) => s+(r.amount||0), 0).toFixed(2)}</strong></Table.Summary.Cell>
                <Table.Summary.Cell></Table.Summary.Cell>
              </Table.Summary.Row>
            ) : null} />
        </Card>

        {data?.top_users && data.top_users.length > 0 && (
          <Card title="TOP 20 用户消耗">
            <Table dataSource={data.top_users} rowKey="user_id" size="small" pagination={false}
              columns={[
                { title: '排名', render: (_, __, i) => i + 1, width: 60 },
                { title: '用户ID', dataIndex: 'user_id' },
                { title: '消费金额', dataIndex: 'amount', render: v => `$${(v||0).toFixed(2)}` },
              ]} />
          </Card>
        )}
      </Spin>
    </div>
  );
};

export default UsageDashboard;
